<div class="container-fluid p-6">
    <div class="row mb-4">
        <div class="col">
            <h6 class="mb-2">ENTWICKLUNG EINER SPIELE APP FÜR IOS GERÄTE</h6>
            <h2>ACTIBOARD - Ein digitales Activity Board für Kinder</h2>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <p>
                Wondermore Games ist ein familiengeführtes Games Studio, das Kinder-Apps mit Herz und Verstand entwickelt. Der Fokus liegt darauf, Kinder sicher durch die mediengeprägte Welt zu begleiten, indem in den Spielen reale und vertraute Elemente integriert werden. Mit liebevoll digitalisierten und animierten echten Objekten schaffen sie eine Brücke zwischen der realen und der digitalen Welt und regen so Neugier und Entdeckungsfreude an.
            </p>
            <p>
                Actiboard ist eine digitale Lernanwendung des Wondermore Games Studios, die Kindern ab zwei Jahren auf spielerische Weise die Prinzipien von Aktion und Reaktion sowie die Welt der Farben, Töne und Formen näherbringt. Die App fördert das Verständnis einfacher Zusammenhänge und unterstützt die kognitive Entwicklung durch wiederholtes Spielen.
            </p>
        </div>
    </div>
    <div class="row" style="margin-top: 3rem">
        <div class="ref-page-header-image"
             style="background-image: url(/assets/images/references/ref-actiboard-full.jpg)"></div>
    </div>
    <div class="row" style="margin-top: 3rem">
        <div class="col-xl-4">
            <h2>TASK & CHALLENGE</h2>
        </div>
        <div class="col-xl-8">
            <p>
                Die Entwicklung einer kindgerechten App, die bewusst auf überflüssige Effekte verzichtet und dennoch die Aufmerksamkeit der jungen Nutzer fesselt, stellte eine besondere Herausforderung dar. Ziel war es, eine realistische und zugleich intuitive Benutzeroberfläche zu gestalten, die eine natürliche Interaktion ermöglicht. Die Designelemente orientierten sich an realen Objekten, deren Animation und Integration besondere technische Anforderungen mit sich brachten. Dabei galt es, die Inhalte kindgerecht und leicht bedienbar aufzubereiten, während Animationen, Soundeffekte und das Gesamtdesign einen realistischen und ansprechenden Eindruck vermitteln sollten.
            </p>
            <img src="/assets/images/references/ref-actiboard-screen.png" class="img-fluid" />
        </div>
    </div>
    <div class="row" style="margin-top: 3rem">
        <div class="col-xl-4">
            <h2>SOLUTION</h2>
        </div>
        <div class="col-xl-8">
            <p>
                Die aheadware GmbH verantwortete bei diesem Projekt die vollständige technologische Umsetzung – beginnend mit dem technischen Konzept, über die Entwicklung verschiedener Prototypen, bis hin zur finalen Realisierung und erfolgreichen Veröffentlichung im Apple App Store.
            </p>
            <p>

                Die Lösung bestand in der Entwicklung einer für das iPad optimierten App. In enger Zusammenarbeit mit Motion-Designern und unter Einsatz des 2D-Skelett-Animationstools Spine2D wurde ein realistisches und flüssiges Bewegungsverhalten der Objekte umgesetzt. Die technische Basis bildeten WebGL und die Graphics Library PIXI.js, welche eine performante und hochwertige Darstellung der Animationen ermöglichten.
            </p>
            <div style="margin-top: 2rem">
                <h4>TECHNOLOGIEN</h4>
                <div class="tech-icons">
                    <img class="img-fluid"
                         src="/assets/images/techicons/white/Infront JS@2x-1.png" />
                    <img class="img-fluid"
                         src="/assets/images/techicons/white/PIXI JS@2x-1.png" />
                    <img class="img-fluid"
                         src="/assets/images/techicons/white/WebGL WebGPU@2x-1.png" />
                    <img class="img-fluid"
                         src="/assets/images/techicons/white/HTML5 CSS3@2x-1.png" />
                </div>
            </div>
        </div>
    </div>
    <div class="row" style="margin-top: 6rem">
        <div class="col-12">
            <div class="p-2 p-lg-5" style="border: 1px solid white;">
                <p>
                “Die aheadware GmbH hat mit der Entwicklung der iOS-App Actiboard eindrucksvoll bewiesen, wie technisches Know-how und Liebe zum Detail zu einer herausragenden Lösung führen können. Besonders beeindruckt hat uns die exzellente technische Umsetzung, die höchste Performance und Stabilität mit kinderleichter Bedienbarkeit kombiniert.”
                </p>
                <p>
                    <i>Judith Jaskowski, CEO und Gründerin</i>
                </p>
            </div>
        </div>
    </div>
</div>
